<template>
  <v-card :color="cardcolor" class="text-right">
    <v-card-text>
      <h5 class="subtitle-1 font-weight-light compress text-uppercase">{{ title }}</h5>
      <h5 class="body-1 font-weight-thin">
          <slot name="subtitle"></slot>
      </h5>
      <h4 class="display-1 font-weight-bold compress grey--text-darken-5">
        <slot name="stat_value"></slot>
      </h4>
      <h5 class="subheading grey--text darken-3">
        <slot name="stat_description"></slot>
      </h5>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    cardcolor: {
      type: String,
      required: false,
      default: 'white'
    }
  }
}
</script>
